/** @format */

import template from './gb-notification-toast-a.html';
import './gb-notification-toast-a.scss';

export const GbNotificationToastAComponent = {
    template,
    require: {
        gbNotificationWidget: '^^',
    },
    bindings: {
        notif: '<',
    },
    controller: class GbNotificationToastAComponent {
        constructor() {
            'ngInject';
        }
    },
};
